import {
  SearchResponse,
  Search,
  SearchOptions,
} from './src/search-platformized-v1-site-document-wix-site-search.universal';
import { NonNullablePaths } from '@wix/sdk-types';

export * from './src/search-platformized-v1-site-document-wix-site-search.universal.js';

/** @hidden */
export type SiteDocumentSearch = {};

/**
 * Retrieves a list of site documents that match the provided search query and optionally performs aggregations on the data queried.
 *
 * The `search()` API supports the document types listed in the [Introduction](https://dev.wix.com/docs/sdk/backend-modules/search/wix-site-search/introduction), each with its own schema. These schemas define the fields available for filtering, sorting, and free-text searching.
 *
 * To learn more about working with the search query, see [API Query Language](https://dev.wix.com/docs/sdk/articles/working-with-the-sdk/api-query-language).
 * @param search - Search query and aggregation information.
 * @public
 * @documentationMaturity preview
 * @requiredField options.documentType
 * @requiredField search
 * @permissionId SEARCH.SITE_DOCUMENT_READ
 * @applicableIdentity APP
 * @fqn wix.search.platformized.v1.SiteSearchPlatformizedService.Search
 */
export declare function search(
  search: Search,
  options: NonNullablePaths<SearchOptions, `documentType`, 2>
): Promise<SearchResponse>;
